/**
 * 値が`null`か`undefined`の場合は`true`を、それ以外の場合は`false`を返します。
 * @param {*} val
 * @returns {boolean}
 */
const isNil = val => val === undefined || val === null;

/**
 * 値が`null`の場合は`true`を、それ以外の場合は`false`を返します。
 * @param {*} val
 * @returns {boolean}
 */
const isNull = val => val === null;

export { isNil, isNull };
